import axios from "axios";

const config = require("../config");

const refreshClient = axios.create();
let refreshPromise = null;

const USER_AUTH_KEYS = [
  "user.token",
  "user.id",
  "user.name",
  "user.email",
  "user.role",
  "user.refresh_token",
  "user.token_expiry",
  "user.client_type",
];

export const clearUserAuthData = () => {
  USER_AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const getAuthorizationToken = (headers = {}) => {
  const authorization = headers.Authorization || headers.authorization;
  if (!authorization || typeof authorization !== "string") {
    return null;
  }

  return authorization.startsWith("Bearer ")
    ? authorization.slice("Bearer ".length)
    : authorization;
};

export const refreshUserToken = () => {
  if (refreshPromise) {
    return refreshPromise;
  }

  const refreshToken = localStorage.getItem("user.refresh_token");
  if (!refreshToken) {
    return Promise.reject(new Error("No refresh token available"));
  }

  const clientType = localStorage.getItem("user.client_type");
  const payload = { refresh_token: refreshToken };
  if (clientType) {
    payload.client_type = clientType;
  }

  refreshPromise = refreshClient
    .post(`${config.api}/user/keycloak/refresh`, payload)
    .then((response) => {
      const { access_token, refresh_token, expires_in, client_type } = response.data;

      // DO NOT overwrite user.token — it holds the local JWT (24h) for API auth.
      // Only update the Keycloak refresh_token and expiry for SSO session tracking.
      localStorage.setItem("user.refresh_token", refresh_token);

      if (client_type) {
        localStorage.setItem("user.client_type", client_type);
      }

      const expiryTime = Date.now() + Number(expires_in || 300) * 1000;
      localStorage.setItem("user.token_expiry", expiryTime.toString());

      return access_token;
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
};
